import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone : false
})
export class AppComponent implements OnInit {
  deferredPrompt: any;

  constructor(private _snackBar : MatSnackBar) {}

  ngOnInit() {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      // Stop Chrome from showing the default mini-infobar
      event.preventDefault();

      // Stash the event so we can trigger later
      this.deferredPrompt = event;

      this._snackBar.dismiss();
      this._snackBar.open('Install as App?', 'Install', {
        duration: 60000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        politeness: 'assertive'
      }).onAction().subscribe(() => {
        
          this.deferredPrompt?.prompt();
          this.deferredPrompt?.userChoice?.then((choiceResult: any) => {
            if (choiceResult?.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            this.deferredPrompt = null;
          });

      });

    });
  }
  
}
